exports = module.exports = require("../../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image[data-v-588a398e]{background-color:#f2f6fc;border:1px dashed #999;border-radius:5px;position:relative}.image .initB[data-v-588a398e],.image>img[data-v-588a398e]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.image img[data-v-588a398e]{display:block;width:100%}.image .initB[data-v-588a398e]{width:30%}.image .initB img[data-v-588a398e]{display:block;width:100%}.image .initB p[data-v-588a398e]{position:absolute;white-space:nowrap;left:50%;transform:translateX(-50%);margin:0;font-size:14px;line-height:24px}.image.enable[data-v-588a398e]:after{position:absolute;width:100%;height:100%;content:\"\";background-color:#c0c4cc;opacity:.4;cursor:not-allowed;left:0;top:0;z-index:11}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?minimize!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-588a398e","scoped":true,"hasInlineConfig":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/packages/compressSub/src/compressSub.vue
// module id = 20
// module chunks = 0